import { Component } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DadosServicosFormComponent } from '../dados-servicos-form/dados-servicos-form.component';
import { Message } from 'primeng/api';
import { selectDeliveryServiceLista, selectDeliveryServiceLoading } from 'src/app/store/delivery-service/delivery-service.selectors';
import { IDeliveryService } from 'src/app/shared/interfaces/deliveryService/ideliveryService';
import { Store } from '@ngrx/store';
import {
  deleteDeliveryService,
  loadDeliveryService,
} from 'src/app/store/delivery-service/delivery-service.actions';
import { loadProfessionalService } from 'src/app/store/professional-service/professional-service.actions';

@Component({
  selector: 'app-dados-servicos',
  templateUrl: './dados-servicos.component.html',
  styleUrls: ['./dados-servicos.component.scss'],
})
export class DadosServicosComponent {
  selectedID = 9999999999999
  mostrarModalExcluir: boolean = false;
  mostrarModalInativar: boolean = false;
  mostrarModalDeletar: boolean = false

  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  lista$ = this.store.select(selectDeliveryServiceLista);
  isLoading$ = this.store.select(selectDeliveryServiceLoading)
  // listaPasta: Array<any> = [
  //   {
  //     nome: 'Consulta Médica',
  //     deliveryTime: '5 dias',
  //     professional: 'João da Silva',
  //   },
  //   {
  //     nome: 'Botox',
  //     deliveryTime: '1 dias',
  //     professional: 'João da Silva',
  //   },
  //   {
  //     nome: 'Progressiva',
  //     deliveryTime: '2 dias',
  //     professional: 'João da Silva',
  //   },
  // ];

  constructor(
    public dialogService: DialogService,
    private modalService: ModalService,
    private store: Store<IDeliveryService>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadDeliveryService());
    this.store.dispatch(loadProfessionalService());
  }

  ref: DynamicDialogRef | undefined;


  public showForm() {
    this.ref = this.dialogService.open(DadosServicosFormComponent, {
      header: 'Selecione o Serviço:',
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });
  }

  editCard(item: IDeliveryService) {
    this.ref = this.dialogService.open(DadosServicosFormComponent, {
      header: 'Selecione o Serviço',
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      dismissableMask: true,
      data: {
        item: item,
      },
    });
  }


  deleteCard(id: number) {
    this.selectedID = id
    this.mostrarModalDeletar = true
    //this.store.dispatch(deleteDeliveryService({ id: id }));
  }

  deleteCardDelete(){
    this.store.dispatch(deleteDeliveryService({ id: this.selectedID }));
    this.fecharDialog()
  }

  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalDeletar = false
    
  }

}
